import styles from "./CartItem.module.scss";
import { Button } from "@eventsquare/uikit";
import { CartItem as CartItemType } from "@type/carts";
import { Product } from "@type/products";
import { useAppContext } from "@context/appContext";
import { RiAddLine, RiSubtractLine } from "@remixicon/react";

interface CartItemProps {
  item: CartItemType;
  index: number;
  product?: Product;
  onEdit?: (item: CartItemType) => void;
  onDelete?: (item: CartItemType) => void;
}

const CartItem = ({ item, product }: CartItemProps) => {
  const { remove, add } = useAppContext();

  return (
    <li className={styles.cartItem}>
      <div className={styles.cartItemBadge}>
        {item.quantity}
      </div>
      <div className={styles.cartItemDetails}>
        <h6 className={styles.cartItemTitle}>
          {product?.name ?? `Item ${item.uid}`}
        </h6>
        <p className={styles.cartItemPrice}>
          {product?.price ? `$${product.price.toFixed(2)}` : "Free"}
        </p>
      </div>
      <div className={styles.cartItemActions}>
        <Button color="subtle" variant="outline" onClick={() => remove(item.uid)} icon><RiSubtractLine /></Button>
        <Button color="subtle" variant="outline" onClick={() => add(item.uid)} icon><RiAddLine /></Button>
      </div>
    </li>
  );
};

export default CartItem;
